import { render } from "./PatientFinder.vue?vue&type=template&id=72dc8cea&scoped=true"
import script from "./PatientFinder.vue?vue&type=script&lang=js"
export * from "./PatientFinder.vue?vue&type=script&lang=js"

import "./PatientFinder.vue?vue&type=style&index=0&id=72dc8cea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dc8cea"]])

export default __exports__